import Model from 'models/Model';
import MediaFile from '../mediaFile/Model.MediaFile';
import StatementEmailTemplate from '../statementEmailTemplate/Model.StatementEmailTemplate';

export default class StatementEmailTemplateAttachment
  extends Model<Model.IStatementEmailTemplateAttachment>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IStatementEmailTemplateAttachment>
{
  id: number;
  languageIsoCode: Locale.Languages;
  statementEmailTemplate: StatementEmailTemplate;
  statementEmailTemplateId: number;
  mediaFile: MediaFile;
  mediaFileId: number;

  constructor(
    data: Partial<Model.IStatementEmailTemplateAttachment> | Utils.FormData<Model.IStatementEmailTemplateAttachment>,
    language?: Locale.Languages
  ) {
    super(
      {
        statementEmailTemplate: StatementEmailTemplate,
        mediaFile: MediaFile,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.id?.toString(),
    };
  }
}
